module.exports = __webpack_public_path__ + "static/img/bananer1.ea6ba65e.png";